var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 98"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#arrow-down_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.341 74.192v-6.545c.211-18.582.634-37.375.846-55.956 0-2.112 0-4.012.211-6.124.212-2.745.846-6.123 4.44-5.49 1.481.212 3.173 3.379 3.384 5.28.846 15.625 1.48 31.039 2.115 46.664.211 3.59 0 7.18 1.903 10.98 2.537-4.223 4.652-8.657 7.4-12.669 1.27-1.9 4.441-4.012 6.345-3.59 3.806.845 3.383 5.068 2.114 7.602-5.498 12.67-10.996 25.55-17.55 37.797-4.23 7.812-10.574 7.812-14.803 0C9.037 81.794 4.808 70.603.156 59.834c-.635-1.267.846-3.379 1.269-5.068 1.691.634 4.229.634 5.075 1.9 2.114 2.535 3.383 5.913 5.075 8.87 1.691 3.166 3.383 6.334 5.074 9.29.423-.422 1.058-.634 1.692-.634"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "arrow-down_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v98H0z"
  })))));
};
export default SvgArrowDown;